import {filter} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss']
})
export class HowItWorksComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.pipe(
      filter(params => params.section))
      .subscribe(params => {
        this.scrollTo(params.section);
      });
  }

  scrollTo(section) {
    const position = document.getElementById(section).offsetTop - 115;
    window.scrollTo(0, position);
  }
}
